<div class="panel-toolbar">
  <div class="panel-toolbar__start">
    @if (itemType) {
    <p-chip
      class="item-type-chip"
      [label]="itemLabel || itemType"
      [pTooltip]="itemTooltip"
      tooltipPosition="top"
      [style.backgroundColor]="itemBackgroundColor || '#F5F5F5'"
      [style.color]="itemColor || '#000000'"
      [ngStyle]="itemBorderStyle">
    </p-chip>
    }
    <span class="panel-node-key">{{ nodeKey }}</span>
  </div>

  <div class="panel-toolbar__actions">
    @if (!hideNavigation) {
    <div class="navigation-buttons">
      @if (isPageItem) {
      <button pButton type="button" class="edit-page-button-visible p-button-text" icon="pi pi-file-edit" [pTooltip]="(isWikiAppConfigured$ | async) ? editPageTooltip : wikiAppNotConfigured" tooltipPosition="left" [disabled]="!(isWikiAppConfigured$ | async)" (click)="onEditPageClicked($event)"></button>
      }
      <button pButton type="button" class="toolbar-icon p-button-text" icon="pi pi-chevron-up" pTooltip="Previous" tooltipPosition="left" (click)="navigatePrevious.emit()"></button>
      <button pButton type="button" class="toolbar-icon p-button-text" icon="pi pi-chevron-down" pTooltip="Next" tooltipPosition="left" (click)="navigateNext.emit()"></button>
    </div>
    <button pButton type="button" class="toolbar-icon p-button-rounded p-button-text" icon="pi pi-times" pTooltip="Close panel" tooltipPosition="left" (click)="closePanel.emit()"></button>
    }
  </div>
  <p-popover #createChildMenu appendTo="body" styleClass="child-menu-popover" (onShow)="onChildMenuShow()">
    <div class="child-menu-content">
      @if (isTestStepSelected && isDoView) {
      <button pButton type="button" label="Test Step" class="p-button-text child-node-button" icon="pi pi-plus" (click)="addTestStep.emit(); createChildMenu.hide()"></button>
      } @for (childNodeName of childNodeNameList; track childNodeName.name) {
      <button type="button" class="child-node-button" (click)="onAddChildNode(childNodeName, createChildMenu)">
        <i class="pi pi-plus"></i>
        <span class="chip-label"
          [style.backgroundColor]="childNodeName.backgroundColor || null"
          [style.color]="childNodeName.textColor || null"
          [ngStyle]="getChildChipBorderStyle(childNodeName)">
          {{ childNodeName.displayName || childNodeName.name }}
        </span>
      </button>
      }
    </div>
  </p-popover>
</div>

<div class="summary-row">
  <input
    pInputText
    id="summaryInput"
    #summaryInput
    name="selectedWorkspaceInstanceNode.name"
    required
    type="text"
    class="summary-input-large"
    maxlength="255"
    [ngModel]="summary"
    (ngModelChange)="onSummaryInput($event)"
    (blur)="summaryBlur.emit(summaryInput.value)"
    placeholder="Enter Name Here" />
</div>

<div class="status-row">
  <div class="status-groups">
    @if (showNodeStatus) {
    <div class="status-dropdown">
      <!-- The tooltip sits on a wrapper: a natively disabled button fires no hover events, so a tooltip on the button itself would never show. -->
      <span class="status-chip-tooltip-host" style="display: inline-block" [pTooltip]="nodeStatusReadOnly ? backlogRollupStatusTooltip : nodeStatusTooltip" tooltipPosition="top">
      <button type="button" class="status-chip" [disabled]="nodeStatusReadOnly" (click)="nodeStatusMenu.toggle($event)" [ngStyle]="nodeStatusChipStyle" [attr.aria-label]="'Item status: ' + nodeStatusLabel">
        <span>{{ nodeStatusLabel }}</span>
        @if (!nodeStatusReadOnly) {
        <i class="pi pi-chevron-down"></i>
        }
      </button>
      </span>
      <p-popover #nodeStatusMenu>
        <div class="status-chip-group status-dropdown-menu">
          @for (icon of nodeStatusIcons; track icon) {
          <button
            type="button"
            class="status-chip"
            [class.active]="isNodeStatusSelected(icon.alt)"
            [pTooltip]="icon.tooltip"
            tooltipPosition="top"
            (click)="onNodeStatusSelect(icon.alt, nodeStatusMenu)"
            [ngStyle]="{ background: icon.style?.color || '#6C7481', color: icon.style?.textColor || '#FFFFFF', border: icon.style?.borderColor ? (icon.style.borderThickness ?? 1) + 'px solid ' + icon.style.borderColor : null }"
            [attr.aria-pressed]="isNodeStatusSelected(icon.alt)">
            {{ icon.alt }}
          </button>
          }
        </div>
      </p-popover>
    </div>
    } @if (showStepStatus) {
    <div class="status-dropdown">
      <button
        type="button"
        class="status-chip status-dropdown__trigger"
        [disabled]="stepStatusReadOnly"
        (click)="stepStatusMenu.toggle($event)"
        [ngStyle]="stepStatusChipStyle"
        [attr.aria-label]="'Test step status: ' + stepStatusLabel">
        <span>{{ stepStatusLabel }}</span>
        @if (!stepStatusReadOnly) {
        <i class="pi pi-chevron-down"></i>
        }
      </button>
      <p-popover #stepStatusMenu>
        <div class="status-chip-group status-dropdown-menu">
          @for (icon of stepStatusIcons; track icon) {
          <button
            type="button"
            class="status-chip"
            [class.active]="isStepStatusSelected(icon.alt)"
            [pTooltip]="icon.tooltip"
            tooltipPosition="top"
            (click)="onStepStatusSelect(icon.alt, stepStatusMenu)"
            [ngStyle]="{ background: icon.style?.color || '#6C7481', color: icon.style?.textColor || '#FFFFFF', border: icon.style?.borderColor ? (icon.style.borderThickness ?? 1) + 'px solid ' + icon.style.borderColor : null }"
            [attr.aria-pressed]="isStepStatusSelected(icon.alt)">
            {{ icon.alt }}
          </button>
          }
        </div>
      </p-popover>
    </div>
    }
  </div>

  @if (canShowGenerateTests) {
  <button
    pButton
    type="button"
    class="generate-tests-button p-button-rounded p-button-text"
    [pTooltip]="generateTestsTooltip"
    tooltipPosition="left"
    [disabled]="isGenerateTestsBlocked"
    (click)="onGenerateTestsClicked()">
    <span class="material-symbols-outlined generate-tests-icon">robot_2</span>
  </button>
  } @if (childNodeNameList.length > 0 || isTestStepSelected) {
  <button
    pButton
    type="button"
    class="add-child-button p-button-rounded p-button-text"
    icon="pi pi-plus"
    pTooltip="Create child item"
    tooltipPosition="left"
    (click)="onCreateChildNodeClicked($event)"></button>
  }
</div>
